var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('s-table',{ref:"table",attrs:{"size":"middle","rowKey":"event_time","pagination":false,"loading":_vm.loading,"columns":_vm.columns,"data":_vm.loadData},scopedSlots:_vm._u([{key:"serial",fn:function(text, record, index){return _c('span',{},[_vm._v(" "+_vm._s(index + 1)+" ")])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }